import React, {FC, useEffect, useState} from "react";
import {Button, Col, Divider, Form, Input, notification, Row} from "antd";
import {useTranslation} from "react-i18next";
import {getEcc, ISaveEccRequest, saveEcc} from "../../../services/eticket/ecc";

interface IProps {
  terminalId: string;
}

export const TerminalPrmETEcc: FC<IProps> = ({terminalId}) => {
  const {t} = useTranslation()
  const [form] = Form.useForm()
  const [formValues, setFormValues] = useState<ISaveEccRequest>();
  const [btnLoading, setBtnLoading] = useState<boolean>(false)
  useEffect(function () {
    if (terminalId !== "") {
      getEcc({terminalId: terminalId}).then(res => {
        if (res.status === 0) {
          setFormValues(res.data)
          form.setFieldsValue(res.data)
        }
      })
    }
  }, [terminalId])
  const saveForm = (values) => {
    if (formValues === undefined) {
      return
    }
    setBtnLoading(true)
    saveEcc({terminalId: terminalId, ecc: values["ecc"]}).then(res => {
      if (res.status === 0) {
        notification.success({
          message: "save success"
        })
      }
    }).finally(() => {
      setBtnLoading(false)
    })
  }
  return (
    <Row gutter={10} style={{marginTop: "20px"}} hidden={terminalId === ""}>
      <div className='form-content-container-content'>
        <Form layout='vertical' form={form} initialValues={formValues} onFinish={saveForm}>
          <Row gutter={30}>
            <Col flex="300px">
              <Form.Item label={t('form.DebugLogFlag')} name={["ecc", "DebugLogFlag"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.DebugLogMaxSize')} name={["ecc", "DebugLogMaxSize"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.DebugLogMaxDays')} name={["ecc", "DebugLogMaxDays"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.TxnLogFlag')} name={["ecc", "TxnLogFlag"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.CardNumMaskCnt')} name={["ecc", "CardNumMaskCnt"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.CardNumMaskOffset')} name={["ecc", "CardNumMaskOffset"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.RetryTimeout')} name={["ecc", "RetryTimeout"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.BlacklistFtpFlag')} name={["ecc", "BlacklistFtpFlag"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.BlacklistFtpIp')} name={["ecc", "BlacklistFtpIp"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.BlacklistFtpPort')} name={["ecc", "BlacklistFtpPort"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.BlacklistFtpId')} name={["ecc", "BlacklistFtpId"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.BlacklistFtpPwd')} name={["ecc", "BlacklistFtpPwd"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.BlacklistLsFilePath')} name={["ecc", "BlacklistLsFilePath"]}>
                <Input/>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Divider/>
        <div>
          <Button type="primary" shape="round" style={{width: "200px", float: "right"}}
                  htmlType="submit" loading={btnLoading} onClick={() => form.submit()}>
            {t('button.save')}
          </Button>
        </div>
      </div>
    </Row>
  )
}